var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppHeader'),_c('div',{staticClass:"container-float"},_vm._l((_vm.companies),function(company){return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('CompanySheet',{attrs:{"company_id":company.registry.id}})],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }